module.exports = __webpack_public_path__ + "img/hopital-general-juif old.adc14dbc.png";